import { desaturate } from "polished";

import { Color } from "@mui/material";
import { green, indigo, orange, red } from "@mui/material/colors";

// Helper function to desaturate all shades in a MUI Color object
const desaturateColor = (color: Color, amount: number = 0.3): Color => {
  const desaturatedColor: Partial<Color> = {};

  // All possible shade keys in MUI Color type
  const shades: (keyof Color)[] = [
    50,
    100,
    200,
    300,
    400,
    500,
    600,
    700,
    800,
    900,
    "A100",
    "A200",
    "A400",
    "A700",
  ];

  shades.forEach((shade) => {
    if (color[shade]) {
      (desaturatedColor as Record<string, string>)[shade] = desaturate(
        amount,
        color[shade],
      );
    }
  });

  return desaturatedColor as Color;
};

export const desaturatedGreen = desaturateColor(green, 0.33);
export const desaturatedIndigo = desaturateColor(indigo, 0.33);
export const desaturatedOrange = desaturateColor(orange, 0.33);
export const desaturatedRed = desaturateColor(red, 0.33);
